/**
 * T573 — Page-size picker (Belege pro Seite).
 *
 * Small dropdown that sits next to the Pagination component on
 * list views. Three options (50/100/200). The hook owns the
 * persistence; this is purely the UI surface.
 */
import { PAGE_SIZE_OPTIONS, type PageSizeOption } from '../../hooks/usePageSizePref';

interface Props {
  value: PageSizeOption;
  onChange: (next: PageSizeOption) => void;
  label?: string;
  className?: string;
}

export function PageSizePicker({ value, onChange, label = 'Pro Seite', className = '' }: Props) {
  return (
    <label className={`flex items-center gap-2 text-xs text-white/60 ${className}`}>
      <span>{label}</span>
      <select
        value={value}
        data-testid="pagesize-select"
        aria-label="Belege pro Seite"
        onChange={(e) => onChange(Number.parseInt(e.target.value, 10) as PageSizeOption)}
        className="bg-white/5 border border-white/10 rounded px-2 py-1 text-xs text-white focus:outline-none focus:ring-1 focus:ring-white/20"
      >
        {PAGE_SIZE_OPTIONS.map((opt) => (
          <option key={opt} value={opt} className="bg-zinc-900 text-white">
            {opt}
          </option>
        ))}
      </select>
    </label>
  );
}
